module.exports = __webpack_public_path__ + "static/media/tensorflow.1f6dff1d.png";